import React,{useState} from 'react';
import {InputAdornment,IconButton,OutlinedInput,InputLabel,FormControl,Button, TextField, Tooltip } from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import EditIcon from '@material-ui/icons/Edit';
export default function Password({ field, onChange, errors = {}, variant = "outlined", value, small = false, onBlur }) {
  let iserror = errors[field.name] ? true : false;
  
  const [showPassword , setShowPassword ] = useState(false);
  const handleChange=(e)=>{
    onChange(e.target.value);
  }
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <>
    <FormControl id={field.name}
        error={iserror}
        required={field.required === 'true' ? true : false}
        name={field.name}
        size={small ? "small" : "medium"}
        label={field.label}
        //onChange={(e) => onChange(e.target.value)}
        value={value}
        variant={variant}
        // placeholder={field.label}
        
        fullWidth
        onBlur={onBlur}
        InputLabelProps={{
          shrink: true,
        }}>
          <InputLabel htmlFor="outlined-adornment-password">{field.label}</InputLabel>
          <OutlinedInput
            fullWidth
            onBlur={onBlur}
            error={iserror}
            required={field.required === 'true' ? true : false}
            name={field.name}
            helperText={errors[field.name] ? errors[field.name] : null}
            id="outlined-adornment-password"
            type={showPassword?'text':'password'}
            value={value}
            onChange={handleChange}
            //disabled={editMode}
            endAdornment={
              <InputAdornment position="end">                
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
                
              </InputAdornment>
            }
            labelWidth={70}
          />
        </FormControl>
    
    {/* <Tooltip
      title={field.comment || ''}
      disableHoverListener={field.comment ? false : true}
      placement="top-start"
      disableFocusListener={field.comment ? false : true}
      disableTouchListener={field.comment ? false : true}
    >
      <TextField
        type="password"
        id={field.name}
        error={iserror}
        required={field.required === 'true' ? true : false}
        name={field.name}
        size={small ? "small" : "medium"}
        label={field.label}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        variant={variant}
        // placeholder={field.label}
        helperText={errors[field.name] ? errors[field.name] : null}
        fullWidth
        onBlur={onBlur}
        InputLabelProps={{
          shrink: true,
        }}
        endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickEditPassword}
                  //onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  <EditIcon />
                </IconButton>
              </InputAdornment>
            }
      />
    </Tooltip> */}
    </>
  );
}
